import { isToday } from './utils'

export const kFormatter = (rawNumber) => {
  const numberToFormat = rawNumber.toFixed(2);

  if (Math.abs(numberToFormat) > 999999) {
    return Math.sign(numberToFormat) * ((Math.abs(numberToFormat) / 1000000).toFixed(1)) + 'm'
  }

  if (Math.abs(numberToFormat) > 999) {
    return Math.sign(numberToFormat) * ((Math.abs(numberToFormat) / 1000).toFixed(1)) + 'k'
  }

  return Math.sign(numberToFormat) * Math.abs(numberToFormat)
}

export const title = (value, replacer = ' ') => {
  if (!value) return ''
  const str = value.toString()

  const arr = str.split(replacer)
  const capitalizedArray = []
  arr.forEach(word => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalizedArray.push(capitalized)
  })
  return capitalizedArray.join(' ')
}

export const avatarText = value => {
  if (!value) return ''
  const nameArray = value.split(' ')
  return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
}

/**
 * Return short human friendly month representation of date
 * Can also convert date to only time if date is of today (Better UX)
 * @param {String} value date to format
 * @param {Boolean} toTimeForCurrentDay Shall convert to time if day is today/current
 */
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// Strip all the tags from markup and return plain text
export const filterTags = value => value.replace(/<\/?[^>]+(>|$)/g, '')
